import React from 'react';
import { useSelector } from 'react-redux';

const SearchContainer = ({ dispatch, ...rest }) => {
  const currentAllUsersSearchFilter = useSelector((state) => state.usersReducer.currentAllUsersSearchFilter);
  return <input type="text" value={currentAllUsersSearchFilter || ''} {...rest} />;
};

// Todo: AAPLAT-8627: removed forwardRef, need to fix
// it introduces error on search field for users
export default SearchContainer;
